<template>
  <div
    :class="{ 'is-loading': loadingChatInfo, 'chat-mode-text': chatInfo?.mode == 'text', 'chat-mode-audio': chatInfo?.mode == 'audio', 'chat-mode-video': chatInfo?.mode == 'video', 'user-is-advisor': isAdvisor }"
    element-loading-text="Loading chat information..." v-if="isAuthenticated">	
    <div class="mobile-timer-wrapper"
         v-if="currentUser && chatInfo && currentUser.active_chat">
      <div>
        <aside class="flex items-center gap-12">
          <se-avatar
            class="hidden 3xs:block 3xs:visible shrink-0"
            v-if="opponentInfo"
            :id="opponentInfo.id"
            :name="opponentInfo.name"
            :src="opponentInfo.avatar"
            :size="32" />
          
          <div class="flex flex-col">
            <p v-if="opponentInfo" class="text-h-s font-semibold truncate w-[100px]">{{ opponentInfo.name }}</p>
            <div v-if="chatInfo.started_at" class="sm:whitespace-nowrap text-h-xs">
              <span class="type text-capitalize" :class="timerClass" v-if="timerType">{{ timerType }}: </span>
              <span v-if="timerType === 'free'">{{ currentChatTimer.toString().toHHMMSS() }}</span>
              <span v-else>{{ currentChatTimer.toString().toHHMMSS() }} <br class="xs:hidden"/><span :class="{'mx-1': smallScreenMode}">(${{ totalAmount }} total)</span></span>
            </div>
            <div v-else>
              <span class="type text-capitalize text-warning">Timer not started </span>
            </div>
          </div>
        </aside>
        
        <aside>
          <button class="btn btn-success btn-sm" @click="askToHireConfirmation = true"
                  :class="{ 'is-loading': askToHireLoading }"
                  v-if="chatInfo && chatInfo.id && isAdvisor && chatInfo.is_free && chatInfo[oppositRole].role_name !== 'admin'"
                  :disabled="chatInfo.status === 'paused'">
            Ask to hire
          </button>
          <button class="btn btn-danger btn-sm hidden md:visible md:block" @click="startCloseChat()" :class="{ 'is-loading': stopTimerLoading }"
                  v-if="chatInfo && chatInfo.status !== 'paused'">
            Close
          </button>
        </aside>
      </div>

      <div class="buttons md:hidden shrink-0" :class="chatInfo.mode">
        <button class="btn btn-light" @click="toggleVideoMute()" title="Toggle camera" v-if="videoMode"
                key="videoToggle">
          <font-awesome-icon icon="video" v-show="videoOn"/>
          <font-awesome-icon icon="video-slash" v-show="!videoOn"/>
        </button>

        <button class="btn btn-light" @click="toggleAudioMute()" title="Toggle microphone"
                v-if="audioMode" key="audioToggle">
          <font-awesome-icon icon="microphone" v-show="audioOn"/>
          <font-awesome-icon icon="microphone-slash" v-show="!audioOn"/>
        </button>

        <button class="btn btn-light" @click="toggleFullscreen()" title="Toggle full screen mode"
                v-if="videoMode" key="fullscreenToggle">
          <font-awesome-icon icon="compress" v-show="fullscreenMode"/>
          <font-awesome-icon icon="expand" v-show="!fullscreenMode"/>
        </button>

        <button class="btn btn-light" @click="startCloseChat()" title="End call" key="close">
          <font-awesome-icon icon="times"/>
        </button>
      </div>

    </div>
    <div class="sidebar-left sidebar-fixed !z-[10000] sm:!z-[10]" id="scrollbar" :class="{ show: isActiveSideBar }"
         v-if="chatInfo && chatInfo.id">
      <div class="sidebar" v-click-outside="hideSideBar">
        <button class="btn btn-info btn-toggle md:hidden" @click="isActiveSideBar = !isActiveSideBar">
          <font-awesome-icon icon="info-circle" class="font-large-1"/>
        </button>
        <div class="sidebar-content card d-none d-lg-block">
          <div class="card-body chat-fixed-search">
            <aside v-if="currentUser && chatInfo && chatInfo.started_at">
              <span class="type text-capitalize" :class="timerClass" v-if="timerType">{{ timerType }}: </span>
              <span v-if="timerType === 'free'">{{ currentChatTimer.toString().toHHMMSS() }}</span>
              <span v-else>{{ currentChatTimer.toString().toHHMMSS() }} (${{ totalAmount }} total)</span>
            </aside>
            <aside v-else>
            </aside>
            <aside>
              <button class="btn btn-success btn-sm" @click="askToHireConfirmation = true"
                      :class="{ 'is-loading': askToHireLoading }"
                      v-if="chatInfo && chatInfo.id && isAdvisor && chatInfo.is_free && chatInfo[oppositRole].role_name !== 'admin'"
                      :disabled="chatInfo.status === 'paused'">
                Ask to hire
              </button>
              <button class="btn btn-danger btn-sm" @click="startCloseChat()"
                      :class="{ 'is-loading': stopTimerLoading }" v-if="chatInfo && chatInfo.status !== 'paused'">
                Close
              </button>
            </aside>
          </div>
          <div id="users-list" class="list-group position-relative">
            <div class="users-list-padding media-list">
              <se-session-side-panel
                :opponent-info="opponentInfo"
                :chat-info="chatInfo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-right" v-if="chatInfo && chatInfo.id">
      <div class="content-wrapper">
        <div class="content-header row">
        </div>
        <div class="content-body">
          <div id="callContainer" v-if="chatInfo.mode !== 'text'" class="callContainer" :class="{ 'fullscreen': fullscreenMode }">
            <div class="buttons hidden md:visible md:flex justify-center" :class="chatInfo.mode">
              <button class="btn btn-light" @click="toggleVideoMute()" title="Toggle camera" v-if="videoMode"
                      key="videoToggle">
                <font-awesome-icon icon="video" class="font-large-1" v-show="videoOn"/>
                <font-awesome-icon icon="video-slash" class="font-large-1" v-show="!videoOn"/>
              </button>

              <button class="btn btn-light" @click="toggleAudioMute()" title="Toggle microphone"
                      v-if="audioMode" key="audioToggle">
                <font-awesome-icon icon="microphone" class="font-large-1" v-show="audioOn"/>
                <font-awesome-icon icon="microphone-slash" class="font-large-1" v-show="!audioOn"/>
              </button>

              <button class="btn btn-light" @click="toggleFullscreen()" title="Toggle full screen mode"
                      v-if="videoMode" key="fullscreenToggle">
                <font-awesome-icon icon="compress" class="font-large-1" v-show="fullscreenMode"/>
                <font-awesome-icon icon="expand" class="font-large-1" v-show="!fullscreenMode"/>
              </button>

              <div v-if="fullscreenMode && currentUser && chatInfo && chatInfo.started_at"
                   class="mt-3 chatTimer">
								<span class="timerBackground">
									<span class="type text-capitalize" :class="timerClass" v-if="timerType">{{ timerType }}:
									</span>
									<span v-if="timerType === 'free'">{{ currentChatTimer.toString().toHHMMSS() }}</span>
									<span v-else>{{ currentChatTimer.toString().toHHMMSS() }} (${{ totalAmount }}
										total)</span>
								</span>
              </div>
            </div>

            <!-- <div class="call-icon">
              <avatar :src="opponentInfo.avatar" :username="opponentInfo.name" :size="200" />
            </div> -->

            <div id="selfVideoPreview" class="selfVideoPreview" v-if="chatInfo.mode == 'video'"></div>
          </div>

          <section class="chat-app-window flex flex-col justify-between pb-16" id="scroll-area" :class="{ 'small-chat': chatInfo.mode == 'video' }"
                   :style="{bottom: `${Math.max(74, formHeight)}px`}">
            <div class="chats" v-if="chatInfo && chatInfo.messages">
              <div class="chats">
                <p class="time font-medium-1 text-success mb-0 mt-1"
                   v-if="chatInfo && chatInfo.is_free && isAdvisor">You are in the Free Chat Mode, press
                  'Ask to hire' button when you want to enter paid time.</p>

                <se-session-messages :chat-info="chatInfo" @onImgModalOpen="openImgModal" system-messages-off/>

              </div>
            </div>

            <div ref="chatBottom" class="flex justify-start">
              <se-typing-bubble v-if="isTyping" class="mt-2"/>
            </div>
          </section>
          <section class="chat-app-form" ref="chatForm">
            <div class="chat-app-input d-flex">
              <fieldset class="form-group position-relative col-1 m-0">
                <div class="form-control-position control-position-right"
                     @click="showEmojiSelector = !showEmojiSelector"
                     :disabled="chatInfo && chatInfo.status === 'paused'">
                  <font-awesome-icon icon="smile"/>
                </div>
              </fieldset>
              <fieldset class="form-group position-relative col-1 m-0">
                <div class="form-control-position control-position-right" @click="initFileInput()"
                     :disabled="chatInfo && chatInfo.status === 'paused'">
                  <font-awesome-icon icon="paperclip"/>
                  <input type="file" accept="image/*" id="upload_image" style="display: none;"
                         @change="sendImage($event)">
                </div>
              </fieldset>
              <fieldset class="form-group position-relative col-8 m-0">
								<textarea class="form-control" placeholder="Type your message" v-model="message"
                          ref="textarea" @keydown.enter.exact="submitSendMessage($event)" @keyup="setIsTyping($event)"
                          :disabled="chatInfo && chatInfo.status === 'paused'" rows="1"></textarea>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left col-2 m-0">
                <button type="button" class="btn btn-primary" @click="submitSendMessage();"
                        :disabled="!message.length && !smallScreenMode || chatInfo && chatInfo.status === 'paused'">
                  <font-awesome-icon icon="paper-plane" class="d-lg-none"/>
                  <span class="d-none d-lg-block">Send</span>
                </button>
              </fieldset>
            </div>
            <suspense>
              <EmojiPicker :native="true" @select="onSelectEmoji" v-show="showEmojiSelector" class="emoji-picker"/>
            </suspense>
          </section>
        </div>
      </div>
    </div>

    <div v-if="!chatInfo || !chatInfo.id">
      <div class="text-center mt-5 pt-5">
        <p>
          No chat started yet.
          <br/>To start, please find an advisor and click on a chat button.
        </p>
        <Link href="/advisors/online" class="btn btn-success font-large-1">
          All online {{ $theme.captions.advisors }}
        </Link>
      </div>
    </div>

    <ConfirmationModal :title="'Ask client to start paid time?'" yesText="Yes" noText="No"
                       :isActive="askToHireConfirmation" :yesLoading="askToHireLoading"
                       @onClose=" askToHireConfirmation = false"
                       @onApprove=" askToHire()" @onReject=" askToHireConfirmation = false"/>

    <div class="img-modal" :class="{ 'is-active': showImage }">
      <div class="modal-background" @click=" showImage = null"></div>
      <div class="modal-content">
        <p class="image">
          <img :src="showImage" id="image">
        </p>
      </div>
      <button class="modal-close" @click=" showImage = null"></button>
    </div>

    <template v-if="chatInfo && chatInfo.status === 'paused' && isUser">
      <!-- Client paused popups -->

      <BootstrapModal :is-active="true" heading="Hire advisor"
                      v-if="chatInfo.is_free">
        <h3 class="popup-heading">Your balance: ${{ Number(currentUser.amount).toFixed(2) }}</h3>
        <p>Advisor wants you to hire him. Start paid time (${{ chatInfo.per_minute_fee }}/min)?</p>
        <template v-slot:buttons>
          <button class="btn btn-danger" @click=" closeChat(true)" :class="{ 'is-loading': unpausing }">Close
            chat
          </button>
          <button class="btn btn-primary" @click="hireAdvisor"
                  :class="{ 'is-loading': askToHireLoading }">Start
          </button>
        </template>
      </BootstrapModal>
      
      
      <se-top-up-balance-popup v-else-if="isPausedToAddFunds" :advisor="opponentInfo" :chat-mode="chatInfo.mode" @close="closeChat(true)"/>
<!--
      <BootstrapModal :is-active="true" :heading="`Session Pause: ${pauseWhenMinutesLeft} Minute Remaining`"
                      :showClose="true" @close="(userDeclinedAddFunds = true) && unPauseChat()"
                      v-else-if="isPausedToAddFunds">
        <p><strong>Attention:</strong> you have only {{ pauseWhenMinutesLeft }} minute of remaining session time. Would you like to add more funds to continue?</p>

        <AddFundsButtons :advisorId="chatInfo.advisor?.id" :chatMode="chatInfo.mode"/>

        <template v-slot:buttons></template>
      </BootstrapModal> -->

      <se-continue-to-paid-chat-popup v-else/>

      <!-- / Client paused popups -->
    </template>

    <template v-if="chatInfo && chatInfo.status === 'paused' && isAdvisor">
      <!-- Advisor paused popups -->

      <BootstrapModal :is-active="true" :showHeader="false"
                      v-if="chatInfo.is_free">
        <p>You have sent `hire` request to client.</p>
        <template v-slot:buttons>
          <button class="btn btn-success" @click=" openMessageModal(opponentInfo)">Send free message</button>
        </template>
      </BootstrapModal>

      <se-wait-for-client-popup
          v-else
          :title="isPausedToAddFunds? 'Your session will continue shortly' : 'Please Wait & Don’t close the chat'"
          :description="isPausedToAddFunds ? 'We’re reaching out to the client for more funds. Hang tight, your session will continue in a moment.'
            : 'We are asking the client to accept paid time.'"
      />

      <!-- / Advisor paused popups -->
    </template>

    <BootstrapModal :is-active="true" heading="Use fullscreen mode for video calls" v-if="suggestFullscreen">
      <p>Video calls are more convenient in full screen mode. The button with the same icon as on the right bottom of
        this message is toggling full screen mode.</p>
      <template v-slot:buttons>
        <button class="btn btn-outline-primary" @click=" suggestFullscreen = false">
          Continue as is
        </button>
        <button class="btn btn-primary" @click=" toggleFullscreen(true); suggestFullscreen = false">
          Switch to fullscreen<br/>
          <font-awesome-icon icon="expand" class="font-large-2"/>
        </button>
      </template>
    </BootstrapModal>

    <se-end-chat-confirmation-popup
        v-if="closeChatConfirmation"
        @close="closeChatConfirmation=false"
        @end-chat="closeChat(true); closeChatConfirmation = false"
    />

  </div>
</template>

<script>
import {mapState, mapActions} from 'pinia'
import {usersStore} from '@/src/store/users'
import {chatStore} from '@/src/store/chat'
import {inboxStore} from '@/src/store/inbox'
import {rootStore} from '@/src/store/root'
import autosize from 'autosize'
import _ from '@/src/helpers/arrayHelpers'
import {TimeCalculations} from '@/src/helpers/timeCalculations'
import {getStorageValue, setStorageValue} from '@/src/helpers/permanentValueStorage'

import BootstrapModal from '@/src/components/BootstrapModal.vue'
import vClickOutside from 'click-outside-vue3'
import ConfirmationModal from '@/src/components/ConfirmationModal.vue'
import AddFundsButtons from '@/src/components/AddFundsButtons.vue'
import SeAvatar from '@/src/shared/ui-kit/avatar/Avatar.vue'
import Link from '@/src/components/Link.vue'
import SeChatHeader from '@/src/modules/chat/components/chat-header.vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faInfoCircle,
  faList,
  faPaperPlane,
  faTimes,
  faSmile,
  faPaperclip,
  faVideoSlash,
  faMicrophone,
  faMicrophoneSlash,
  faCompress,
  faExpand
} from '@fortawesome/free-solid-svg-icons'

library.add(faInfoCircle, faList, faPaperPlane, faTimes, faSmile, faPaperclip, faVideoSlash, faMicrophone, faMicrophoneSlash, faCompress, faExpand)

import {defineAsyncComponent} from 'vue'
import ChatSystemMessage from "@/src/components/ChatSystemMessage.vue";
import SeContinueToPaidChatPopup from "@/src/modules/chat/components/popups/continue-to-paid-chat-popup.vue";
import SeTopUpBalancePopup from "@/src/modules/chat/components/popups/top-up-balance-popup.vue";
import SeWaitForClientPopup from "@/src/modules/chat/components/popups/wait-for-client-popup.vue";
import SeEndChatConfirmationPopup from "@/src/modules/chat/components/popups/end-chat-confirmation-popup.vue";
import SeSessionMessages from "@/src/modules/chat/components/session-elements/session-messages.vue";
import SeMessageBubble from "@/src/shared/ui-kit/message-bubble/MessageBubble.vue";
import SeTypingBubble from "@/src/modules/chat/components/shared/typing-bubble.vue";
import SeSessionSidePanel from "@/src/modules/chat/components/session-elements/session-side-panel.vue";

const EmojiPicker = defineAsyncComponent(() => import('/node_modules/vue3-emoji-picker/dist/emoji-picker.es.js'))

let chat = null
let user = null
export default {
  meta() {
    return {
      title: "Active chat",
    }
  },
  setup() {
    chat = chatStore()
    user = usersStore()
	chat.setChatInfoLoading(true)
  },
  data() {
    return {
      formHeight: 0,
      now: null,
      amount: null,
      askToHireConfirmation: false,
      askToHireLoading: false,
      // stopTimerLoading: false,
      showImage: null,
      showBlock: null,
      recentChats: [],
      loadingSideBarInfo: false,
      pausing: false,
      isActiveSideBar: false,
      typingTimeout: null,
      fullscreenMode: false,
      chatOnAirInterval: null,
      suggestFullscreen: false,
      // closingChat: false,
      closeChatConfirmation: false,
      isFree: true,
      pausingChat: false,
      showEmojiSelector: false,
      // pauseWhenMinutesLeft: 1,
      userDeclinedAddFunds: false,
    }
  },
  components: {
    SeSessionSidePanel,
    SeTypingBubble,
    SeMessageBubble,
    SeSessionMessages,
    SeEndChatConfirmationPopup,
    SeWaitForClientPopup,
    SeTopUpBalancePopup,
    SeContinueToPaidChatPopup,
    ChatSystemMessage,
    BootstrapModal,
    ConfirmationModal,
    AddFundsButtons,
    SeAvatar,
    Link,
    FontAwesomeIcon,
    EmojiPicker,
	SeChatHeader
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mounted() {
	this.setChatInfoLoading(true)
    // this.getTimeDifference()
    this.now = TimeCalculations.getCurrentTime()
    setInterval(function () {
      this.now = TimeCalculations.getCurrentTime()
    }.bind(this), 1000)

    document.body.classList.add('chat-application')

    if (document.documentElement.clientWidth < 991 && !this.$route.query.id) {
      this.isActiveList = true
    }

    // Catching when exiting full screen mode.
    document.documentElement.addEventListener('fullscreenchange', (event) => {
      if (!document.fullscreenElement) {
        this.toggleFullscreen(false)
      }
    })
  },
  watch: {
    currentUser() {
      if (this.currentUser.active_chat) {
        this.getChatInfo(this.currentUser.active_chat.id)
      } else {
		this.setChatInfoLoading(false)
	  }
    },
    'currentUser.email'(userEmail) {
      if (this.currentUser?.email && this.opponentInfo?.url && this.isUser) {
        this.$analytics.sendStartChatEvent(this.currentUser.email, this.currentUser.id, this.opponentInfo.url)
      }
    },
    'opponentInfo.url'(advisorUrl) {
      if (this.currentUser?.email && this.opponentInfo?.url && this.isUser) {
        this.$analytics.sendStartChatEvent(this.currentUser.email, this.currentUser.id, this.opponentInfo.url)
      }
    },
    "currentUser.active_chat.started_at"() {
      if (this.currentUser?.active_chat?.started_at) {
        // Updating chat information when chat is considered started (it's not updated itself).
        this.getChatInfo(this.currentUser.active_chat.id)
      }
    },
    "chatInfo.id"() {
      if (this.chatInfo?.mode === 'video' || this.chatInfo?.mode === 'audio')
        document.body.classList.add('chat-application-call')

      if (this.chatInfo.id) {

        // Resuming chat if there is enough funds to chat.
        // if (this.chatInfo.status == 'paused' && !this.userMoneyForFewMinutesLeft) {
        if (this.chatInfo.status == 'paused' && !this.notEnoughFunds) {
          this.$nextTick(function () {
            this.unPauseChat()
          })
        }

        // Opening keyboard on page load and reload.
        this.$nextTick(function () {
          this.$refs.textarea.focus()
        })

      } else {
        if (this.fullscreenMode) {
          this.toggleFullscreen(false)
        }
      }
    },
    "chatInfo.status"(status) {
      if (['video', 'audio'].includes(this.chatInfo.mode)) {
        if (status == 'paused') {
          this.$video.disconnect()
          if (this.fullscreenMode) {
            this.toggleFullscreen(false)
          }
        } else {
          this.$nextTick(function () {
            this.restartChat()
            // this.toggleFullscreen(true)

            // Sending a message marking that the chat started successfully.
            let _this = this
            setTimeout(async function () {
              if (_this.$video.isOnAir() && !_this.$video.hasMalfunction()) {
                await _this.sendChatStartMessages()
              }
            }, 15 * 1000)
          })
        }
      }

      if (status == 'active') {
        // Calculating free/paid on page refresh.
        this.updateIsFreeStatus()

        this.$nextTick(function () {
          // Opening keyboard on chat unpaused.
          this.$refs.textarea.focus()
        })
      }

    },
    "chatInfo.started_at"(started_at) {
      if (started_at) {
        // Calculating free/paid on chat started after some messages.
        this.updateIsFreeStatus()
      }
    },
    "chatInfo.messages.length"() {
      this.scrollToMessage()
      // Considering image uploading delay.
      setTimeout(function () {
        this.scrollToMessage()
      }.bind(this), 1000)
    },
    isTyping(newValue) {
      let element = document.getElementById("scroll-area");
      if (newValue && element.scrollHeight <= (element.scrollTop + element.clientHeight)) {
        this.scrollToMessage()
      }
    },
    chatMessage() {
      this.message = this.chatMessage;
    },
    showBlock(val) {
      if (val === 'chats') {
        if (!this.recentChats.length)
          this.getRecentChats();
      } else if (val === 'payments') {
        if (!this.inbox || !this.chatTransactions.length)
          this.getPaymentsInfo();
      }
    },
    message() {
      // this.message = this.message.replace(/[\n\r]+$/, '')

      this.updateTextareaSize()
    },
    currentChatTimer() {
      if (this.currentUser?.active_chat?.status == 'active') {
        if (this.timerType == 'free' && this.currentChatTimer <= 0) {
          if (!this.pausingChat) {
            this.pausingChat = true

            // Pausing free chat when time is out.
            this.$api.post('/api/chat/paid-time-pause', {})
              .then(res => {
                
                this.pausingChat = false
              })
              .catch(error => {
                console.error(error.response)
                this.pausingChat = false
              });
          }
          // } else if (
          // 	this.timerType == 'paid'
          // 	&& this.userMoneyForFewMinutesLeft
          // 	&& !this.userDeclinedAddFunds
          // ) {
          // 	// Showing dialog suggesting to add funds.
          // 	this.pauseChatToAddFunds()
        } else if (
          this.timerType === 'paid'
          && this.isUser
          // && Number(this.currentUser.amount) > 0
          && this.notEnoughFunds
        ) {
          // Showing dialog suggesting to add funds.
          this.pauseChatToAddFunds()
          // // Closing paid chat when user runs out of funds next second.
          // this.closeChat()
        }
      }
    },
  },
  methods: {
    ...mapActions(usersStore, [
      'submitAddFunds',
    ]),
    ...mapActions(chatStore, [
      'scrollToMessage',
      'getChatInfo',
      'sendMessage',
      'sendImage',
      'pauseChatToAddFunds',
      'unPauseChat',
      'setMessage',
      'closeChat',
      'sendChatProgressMessages',
      'sendChatStartMessages',
	  'setChatInfoLoading',
    ]),
    ...mapActions(inboxStore, [
      'openMessageModal',
    ]),
    updateTextareaSize() {
      if (this.$refs.textarea) {
        this.$refs.textarea.dispatchEvent(new Event("autosize:destroy"))
      }
      this.$nextTick(() => {
        autosize(this.$refs.textarea)
      })
    },
    updateIsFreeStatus() {
      const chatSeconds = this.chatLength(this.chatInfo)
      const free_seconds = this.chatFreeSeconds(this.chatInfo)
      const paused_seconds = this.chatPausedSeconds(this.chatInfo)
      this.isFree = (this.chatInfo.free_minutes > 0) && (chatSeconds + 10 < free_seconds + paused_seconds)
    },
    hideSideBar() {
      this.isActiveSideBar = false;
    },
    openImgModal(url) {
      console.log("openImgModal", url)
      this.showImage = url;
    },
    groupMessages(messages) {
      if (!this.chatInfo || !this.chatInfo.messages)
        return [];
      messages = _.sortBy(messages, item => item.created_at);
      return messages.reduce((grouped, message) => {
        // Skipping displaying system messages.
        if (!message.is_system) {
          if (!grouped.length || grouped[grouped.length - 1].sender_id !== message.sender_id) {
            grouped.push({
              sender_id: message.sender_id,
              messages: [message],
            })
          } else {
            grouped[grouped.length - 1].messages.push(message)
          }
        }
        return grouped;
      }, []);
    },
    startCloseChat() {
      this.closeChatConfirmation = true
    },
    toggleVideoMute() {
      if (this.$video) {
        this.$video.toggleVideoMute()
        this.$forceUpdate()
      }
    },
    toggleAudioMute() {
      if (this.$video) {
        this.$video.toggleAudioMute()
        this.$forceUpdate()
      }
    },
    toggleFullscreen(value = null) {
      let modeChanged = false
      let newModeValue = this.fullscreenMode
      if (value === null) {
        newModeValue = !this.fullscreenMode
        modeChanged = true
      } else {
        if (this.fullscreenMode !== value) {
          newModeValue = value
        }
        // If mode is set, forcing it to be set.
        modeChanged = true
      }

      if (modeChanged) {
        if (newModeValue) {
          let elem = document.documentElement
          let fullScreenRequest = null
          if (elem.requestFullscreen) {
            fullScreenRequest = elem.requestFullscreen();
          } else if (elem.webkitRequestFullscreen) { // Safari
            fullScreenRequest = elem.webkitRequestFullscreen();
          } else if (elem.msRequestFullscreen) { // IE11
            fullScreenRequest = elem.msRequestFullscreen();
          }
          if (fullScreenRequest) {
            fullScreenRequest.catch((err) => {
              // Displaying instructions how to switch to full screen manually if can't do automatically.
              if (!getStorageValue('dontSuggestFullscreen')) {
                this.suggestFullscreen = true
                setStorageValue('dontSuggestFullscreen', 'true', 365)
              }
            });
          }
        } else {
          if (document.exitFullscreen && document.fullScreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen && document.webkitIsFullScreen) { // Safari
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen && document.msIsFullScreen) { // IE11
            document.msExitFullscreen();
          }
        }

        this.fullscreenMode = newModeValue

        // this.restartChat()
      }
    },
    async restartChat() {
      this.pausingChat = false

      // Refs with v-if on the page are not working, so using getElementById.
      let selfVideoPreviewElement = document.getElementById('selfVideoPreview')
      let callContainerElement = document.getElementById('callContainer')
      await this.$video.disconnect()
      if (this.chatOnAirInterval) {
        clearInterval(this.chatOnAirInterval)
        this.chatOnAirInterval = null
      }
      await this.$video.init(this.currentUser.id, this.opponentInfo.id, selfVideoPreviewElement, callContainerElement, this.videoMode, this.audioMode)
      let _this = this
      let allowedErrors = 5
      let errorCount = 0
      this.chatOnAirInterval = setInterval(function () {
        if (_this.$video.isOnAir()) {
          if (!_this.$video.hasMalfunction()) {
            _this.sendChatProgressMessages()
            errorCount = 0
          } else {
            console.error('[on air]', 'malfunction')
            errorCount++
          }
        }
        // Reinitializing the chat in case if video is not working.
        if (errorCount >= allowedErrors) {
          _this.restartChat()
        }
      }, 15 * 1000)

      // Displaying information how to switch to full screen mode.
      setTimeout(function () {
        if (_this.videoMode) {
          _this.toggleFullscreen(true)
        }
      }, 5000)
    },
    //initiate file input on button click
    initFileInput() {
      document.getElementById('upload_image').click();
    },
    //accept ask to hire request (client)
    hireAdvisor() {
      this.askToHireLoading = true;
      this.$api.post('/api/chat/hire-advisor', {})
        .then(res => {
          this.askToHireLoading = false;
        })
        .catch(error => {
          this.askToHireLoading = false;
        })
    },
    //ask to hire (free chat/advisor)
    askToHire() {
      if (!this.chatInfo.is_free)
        return false;

      this.askToHireLoading = true;
      this.$api.post('/api/chat/hire', {})
        .then(res => {
          this.askToHireConfirmation = false;
          this.askToHireLoading = false;
        })
        .catch(error => {
          this.askToHireConfirmation = false;
          this.askToHireLoading = false;
        })

    },
    getRecentChats() {
      this.loadingSideBarInfo = true;
      this.$api.get('/api/chat/opponent-info/recent-chats')
        .then(res => {
          this.recentChats = res.data;
          this.loadingSideBarInfo = false;
          
        })
        .catch(error => {
          console.error(error);
          this.loadingSideBarInfo = false;
        })
    },
    showInboxBlock(block) {
      this.showBlock = this.showBlock === block ? null : block;
    },
    toMyTimezone(time) {
      return TimeCalculations.formatTime(time, false, true)
    },
    //reformat recent chats dates
    formatDate(time) {
      return TimeCalculations.formatTime(time, false, false, false, false)
    },
    alignFormHeight() {
      const formHeight = this.$refs.chatForm.clientHeight;
      if (this.formHeight !== formHeight) {
        this.formHeight = formHeight;
        this.$refs.chatBottom.scrollIntoView({behavior: 'instant'});
      }
    },
    //send client event (is typing) to socket server
    setIsTyping(event) {
      this.alignFormHeight()
      if (event.keyCode === 13 || event.keyCode === 17 || event.keyCode === 18) {
        // returning false will prevent the event from bubbling up.
        return false
      }

      const opponentId = this.opponentInfo?.id
      if (opponentId) {
        // Notifying other user that the current one is typing.
        if (!this.typingTimeout) {
          this.$messaging.sendTypingChatMessage(this.currentUser.id, opponentId, this.chatInfo.id, true)
        }
        clearTimeout(this.typingTimeout);
        // Make a new timeout set to go off in some time.
        this.typingTimeout = setTimeout(function () {
          this.$messaging.sendTypingChatMessage(this.currentUser.id, opponentId, this.chatInfo.id, false)
          this.typingTimeout = null
        }.bind(this), 3000)
      }
    },
    submitSendMessage(event) {
      this.message = this.message.replace(/[\n\r]+$/, '')

      if (event) {
        event.preventDefault()
      }

      // Keeping keyboard open.
      this.$refs.textarea.focus();

      const opponentId = this.opponentInfo?.id
      if (opponentId) {
        // Send to opponent an event that current stoped typing.
        this.$messaging.sendTypingChatMessage(this.currentUser.id, this.chatInfo.id, false)
      }

      if (this.message === '' || this.message.trim() === '') {
        this.message = '';
        return false;
      }
      //send message
      this.sendMessage(this.message);
    },
    onSelectEmoji(emoji) {
      this.message += emoji.i
      this.showEmojiSelector = false
    },
  },
  computed: {
    ...mapState(rootStore, [
      'smallScreenMode',
    ]),
    ...mapState(usersStore, [
      'currentUser',
      'typing_now',
      'addFundsLoading',
      'isAuthenticated',
      'isUser',
      'isAdvisor',
    ]),
    ...mapState(chatStore, [
      'chatInfo',
      'loadingChatInfo',
      'unpausing',
      'pausing',
      'chatMessage',
      'audioOn',
      'videoOn',
      'stopTimerLoading',
      'chatLength',
      'chatFreeSeconds',
      'chatPausedSeconds',
    ]),
    message: {
      get: () => chat.message,
      set: val => {
        chat.setMessage(val)
      }
    },
    timerType() {
      if (!this.currentUser || !this.chatInfo) {
        return null
      } else if (this.chatInfo.status === 'paused' || this.chatInfo.status === 'paused') {
        return 'paused'
      } else if (this.chatInfo.is_free) {
        return 'free'
      } else if (this.isFree) {
        return 'free'
      } else {
        return 'paid'
      }
    },
    currentChatTimer() {
      if (!this.chatInfo?.id || !this.currentUser?.active_chat?.started_at) {
        return 0;
      }

      let now = this.now // triggering change of value each second.

      const chatSeconds = this.chatLength(this.chatInfo)
      const free_seconds = this.chatFreeSeconds(this.chatInfo)
      const paused_seconds = this.chatPausedSeconds(this.chatInfo)

      if (this.chatInfo.is_free) {
        return chatSeconds
      }

      if (this.timerType == 'free') {
        return Math.max(0, free_seconds - chatSeconds + paused_seconds)
      } else if (this.timerType == 'paid' || this.timerType == 'paused') {
        return Math.max(0, chatSeconds - free_seconds - paused_seconds)
      } else {
        return 0
      }
    },
    totalAmount() {
      if (!this.chatInfo || !this.chatInfo.id) {
        return 0;
      }

      return (this.chatInfo.paid_minutes * this.chatInfo.per_minute_fee).toFixed(2);
    },
    oppositRole() {
      return this.isUser ? 'advisor' : 'client';
    },
    isTyping() {
      if (!this.chatInfo || !this.chatInfo.id)
        return false;
      let filtered = _.filter(this.typing_now, item => item.type === 'chat' && item.user === this.chatInfo[this.oppositRole].id && item.chat_id === this.chatInfo.id);
      return filtered.length > 0;
    },
    transformedPromotions() {
      return _.chain(this.promotions).filter(item => item.off > 0).map(item => {
        if (item.off)
          item.label = '$' + item.amount + ' (' + item.off + '% OFF - Save $' + item.amount * item.off / 100 + ')';
        else
          item.label = '$' + item.amount;
        return item;
      }).value();
    },
    opponentInfo() {
      if (!this.chatInfo || !this.chatInfo.id)
        return null;
      return this.chatInfo[this.oppositRole];
    },
    timerClass() {
      switch (this.timerType) {
        case 'paid':
          return 'text-warning';
        case 'free':
          return 'text-success';
        default:
          return '';
      }
    },
    videoMode() {
      return ['video'].includes(this.chatInfo.mode)
    },
    audioMode() {
      return ['video', 'audio'].includes(this.chatInfo.mode)
    },
    isPausedToAddFunds() {
      return this.chatInfo &&
        this.chatInfo.status === 'paused' &&
        (this.timerType == 'paid' || this.timerType == 'paused') &&
        // Considering that the chat that had paid minutes is paused for adding funds.
        this.chatInfo.paid_minutes > 0
    },
    // // Works for user only.
    // userMoneyForFewMinutesLeft() {
    // 	return this.isUser &&
    // 		Number(this.currentUser.amount) < (this.pauseWhenMinutesLeft + this.chatInfo.paid_minutes) * this.chatInfo.per_minute_fee &&
    // 		// Skipping the case when user has not enough funds for paid chat and free chat ended.
    // 		this.chatInfo.paid_minutes > 0 &&
    // 		// Skipping the case when the chat is closing with not enough funds.
    // 		this.currentChatTimer < 60 * (Math.floor(this.currentUser.amount / this.chatInfo.per_minute_fee) - 0.25)
    // },
    notEnoughFunds() {
      return Number((Math.ceil((this.currentChatTimer + 1) / 60) * this.chatInfo.per_minute_fee).toFixed(2))
        > Number(Number(this.currentUser.amount).toFixed(2))
    },
  }
}
</script>

<style lang="scss">
@import "/static/assets/css/pages/chat-application";
@import "/node_modules/vue3-emoji-picker/dist/style";
</style>

<style scoped lang="scss">
@import "@/src/styles/variables";

body,
html {
  overflow-y: hidden;
  overflow-y: clip;
}

$window-background-color: #ffffff;
$video-chat-md-height: 40vh;
$video-chat-sm-height: 34.5vh;
$video-chat-xs-height: 27.4vh;
//$mini-chat-height: 65vh;

.sidebar-left {
  padding-right: 17px;
  overflow: hidden;
  height: calc(100% - 144px);

  .sidebar {
    margin-right: -17px;
  }
}

p.list-group-item-text {
  max-width: 210px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: transparent;
}

.sidebar-content {
  box-shadow: none;
  min-height: calc(100vh - 144px);
  margin-bottom: 0;
  width: 300px;

  .users-list-padding {
    padding-bottom: 0;
  }
}

.users-list-padding {
  padding: 95px 15px 0;

  .user-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
    padding: 10px 0;

    .collapse-icon {
      width: 100%;

      .card-header {
        &:not(:first-child) {
          border-top: 1px solid #e6e6e6;
        }
      }

      .card-title {
        font-weight: 400;
      }

      .card-body {
        padding-top: 0;
      }
    }

    ul {
      font-size: .9rem;
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-top: 5px;

        p {
          margin: 0;
        }

        &:hover {
          .action-anchors {
            height: 21px;
          }
        }

        .action-anchors {
          margin-top: 3px;
          height: 0;
          overflow: hidden;
          -webkit-transition: all .3s ease-in-out;
          -moz-transition: all .3s ease-in-out;
          -ms-transition: all .3s ease-in-out;
          -o-transition: all .3s ease-in-out;
          transition: all .3s ease-in-out;

          a {
            opacity: .5;
            border: none;
            display: inline;
            background-color: transparent;

            &:hover {
              background-color: transparent;
              opacity: 1;
            }
          }
        }
      }
    }
  }
}

.chat-fixed-search {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

p.list-group-item-text {
  max-width: 210px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: transparent;
}

.btn-toggle {
  position: absolute;
  top: 25vh;
  height: 50px;
  width: 50px;
}

.sidebar-left {
  .btn-toggle {
    //display: none;
    right: -50px;
    top: 15vh;
    border-radius: 0 4px 4px 0;
  }

  @media screen and (max-width: $tablet) {
    height: 100vh;
    position: fixed;
    width: 300px;
    top: 0;
    left: -300px;
    background-color: white;
    overflow: inherit;
    padding: 0;
    z-index: 10000 !important;

    -webkit-transition: all ease-in-out .3s;
    -moz-transition: all ease-in-out .3s;
    -ms-transition: all ease-in-out .3s;
    -o-transition: all ease-in-out .3s;
    transition: all ease-in-out .3s;

    @media screen and (min-width: $mobile) {
      .btn-toggle {
        display: block;
      }
    }

    &.show {
      left: 0;
    }

    .sidebar-content {
      display: flex !important;
    }
  }
}

.mobile-timer-wrapper {
  z-index: 10000 !important;
  position: fixed;
  background-color: white;
  height: 4.5rem;
  width: calc(100% - 0px);
  left: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  top: 0;
  padding: 0 0.5rem;

  @media screen and (min-width: $desktop) {
    display: none;
  }
}

.img-modal {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
  display: none;
  justify-content: center;
  align-items: center;

  &.is-active {
    display: flex;
  }

  .modal-background {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 100vw;
    height: 100vh;
  }

  .modal-content {
    width: 100%;
    height: 100%;
    max-width: 400px;
    max-height: 400px;
    margin: auto;
    background: transparent;
    border: none;
    box-shadow: none;
  }
}

.hide-mobile {
  @media screen and (max-width: $tablet) {
    display: none;
  }
}

.img-modal {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
  display: none;
  justify-content: center;
  align-items: center;

  &.is-active {
    display: flex;
  }

  .modal-background {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 100vw;
    height: 100vh;
  }

  .modal-content {
    width: calc(100% - 50px);
    height: calc(100% - 50px);
    max-width: 600px;
    max-height: 600px;
    margin: auto;
    background: transparent;
    border: none;
    box-shadow: none;

    img {
      width: 100%;
    }
  }
}

.collapse-icon a[data-toggle="collapse"]::before {
  content: '\FF1E';
  transform: rotate(90deg);
}

.collapse-icon a[data-toggle="collapse"]::after {
  content: '\FF1C';
  transform: rotate(90deg);
}

.media-list .user-info {
  width: 100%;
}

.card-header {
  padding: 0;
}

.card-header a {
  display: inline-block;
  width: 100%;
  height: 100%;
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  padding-top: 1em;
}

/* Video-audio call test interface. */
#callContainer:not(.fullscreen) {
  position: fixed;
  width: calc(1020px - 1.5rem);
  left: calc((100% - 1320px) / 2 + 0.75rem + 300px);
}

.callContainer.fullscreen {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  // display: none;
  // z-index: 1000000;
  z-index: 100000;
  background-color: $window-background-color;
}

.callContainer.fullscreen .call-icon {
  position: fixed;
  left: calc(50% - 3rem);
  top: calc(50% - 7rem);
  width: auto;
  height: auto;
  display: none;
}

.callContainer.fullscreen .call-icon svg {
  width: 6rem;
  height: 6rem;
}

.callContainer.enabled {
  display: block;
}

.callContainer .audio-only,
.callContainer .video-only {
  display: none;
}

.callContainer.audio:not(.video) .audio-only,
.callContainer.audio.video .video-only {
  display: block;
}

.callContainer.fullscreen .buttons {
  position: fixed;
  top: 1rem;
  left: 0;
  width: 100%;
  text-align: center;
  // z-index: 1000010;
  z-index: 1000010;

}

.callContainer.fullscreen .selfVideoPreview {
  display: block;
  position: fixed;
  // z-index: 1000015;
  z-index: 1000015;
}

/* Video chat interface */
.callContainer {
  display: block;
  position: relative;
  width: 100%;
  height: $video-chat-md-height;
  z-index: 10;
  /*
  position: fixed;
  width: 95vw;
  height: 80vh;
  border: solid 1px red;
  background: red;
*/
}

.callContainer .selfVideoPreview {
  /*display: none;*/
  position: absolute;
  bottom: 3rem;
  right: 3rem;
  width: 10rem;
  height: 15rem;
  z-index: 15;
  background-color: $window-background-color;
}

.callContainer .call-icon {
  position: absolute;
  left: calc(50% - 3rem);
  top: calc(50% - 7rem);
  width: 6rem;
  height: 6rem;
}

.callContainer .buttons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 20;
}

/*
@media screen and (min-width: $desktop) {
	.callContainer:not(.fullscreen) {
		position: absolute;
		width: 300px;
		height: 300px;
		margin-top: 55px;
		left: calc(50% - 480px + 0.75rem);
	}
}
*/
@media screen and (min-width: $desktop) {
  .callContainer:not(.fullscreen) {
    left: calc(50% - 328px + 0.75rem);
  }
}

@media screen and (min-width: $widescreen) {
  .callContainer:not(.fullscreen) {
    left: calc(50% - 420px + 0.75rem);
  }
}

@media screen and (min-width: $fullhd) {
  .callContainer:not(.fullscreen) {
    left: calc(50% - 510px + 0.75rem);
  }
}

.chatTimer {
  text-align: center;
}

.chatTimer .timerBackground {
  background: $window-background-color;
  padding: 0.5rem;
  border-radius: 0.2rem;
}

/*
@media screen and (max-width: $desktop) {
	.chat-app-window.small-chat {
		margin-top: $small-chat-height;
	}
}
*/
.chat-app-window.small-chat {
  margin-top: $video-chat-md-height;
}


@media screen and (min-width: $tablet) {
  .content-body .chat-app-window.small-chat#scroll-area {
    margin-top: $video-chat-sm-height;
  }
}


@media screen and (max-width: $tablet) {
  //.content-body .chat-app-window.small-chat#scroll-area {
  //	margin-top: $video-chat-sm-height;
  //}

  .callContainer {
    height: $video-chat-sm-height;
  }

  .chat-mode-text .callContainer {
    height: 3rem;
  }

  .user-is-advisor.chat-mode-text .callContainer {
    // margin-top: 4rem;
  }
}


@media screen and (min-width: $mobile) {
  .content-body .chat-app-window.small-chat#scroll-area {
    margin-top: $video-chat-xs-height;
  }
}

@media screen and (max-width: $mobile) {
  .content-right {
    z-index: 10;
    position: relative;
  }
  .callContainer {
    height: 52vh;
    position: unset;
  }

  .callContainer .selfVideoPreview {
    bottom: 10rem;
    right: 1rem;
    width: 6.67rem;
    height: 10rem;
  }

  .callContainer .buttons {
    text-align: right;
    top: 0.9rem;
    padding-right: 0.5rem;
    z-index: 10020;
    display: flex;
    justify-content: center;
  }
  .callContainer:not(.fullscreen) .buttons .font-large-2 {
    font-size: 1.7rem !important;
  }

  .buttons.video,
  .buttons.audio {
    margin-top: 0rem;
  }
}

.hint {
  color: #8F8F8F;
  font-size: 1rem;
}
</style>
